const LOGIN_URL = 'auth?targetApp=account'
const REFRESH_TOKEN_URL = 'api/global/jwt/refreshtoken'
const LOGOUT_URL = 'api/global/jwt/logout'

const POST_OPTIONS = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  }
}

export interface AccessTokenResponse {
  readonly accessToken: string
}

export interface AuthApi {
  readonly redirectToLoginPage: () => void
  readonly refresh: () => Promise<string | undefined>
  readonly logout: () => Promise<void>
}

export function createAuthApi(baseUrl: string): AuthApi {
  function redirectToLoginPage(): void {
    window.location.replace(`${baseUrl}/${LOGIN_URL}`)
  }

  async function refresh(): Promise<string | undefined> {
    try {
      const response = await fetch(`${baseUrl}/${REFRESH_TOKEN_URL}`, {
        ...POST_OPTIONS,
        credentials: 'include'
      })
      const { accessToken } = (await response.json()) as AccessTokenResponse

      return accessToken
    } catch (error) {
      return undefined
    }
  }

  async function logout(): Promise<void> {
    await fetch(`${baseUrl}/${LOGOUT_URL}`, {
      ...POST_OPTIONS,
      credentials: 'include'
    })
    redirectToLoginPage()
  }

  return {
    redirectToLoginPage,
    refresh,
    logout
  }
}
